class ProductKitUniforme extends HTMLElement {
  constructor() {
    super();
    this.totalPriceElement = document.querySelector('.price-item.price-item--regular');
    this.totalPriceProductBar = document.querySelector('.product-bar__price');
    this.addToCartButton = document.querySelector('.add-bundle-to-cart');
    this.init();
  }

  init() {
    this.attachSwatchListeners();
    this.attachAddToCartListener();
    this.attachKitImageClickHandler();
    this.updateTotalPrice();
    this.initGlobalCRESelector();
  }

  initGlobalCRESelector() {
    const globalCRERadios = this.querySelectorAll('input[name="global-cre"]');
    if (globalCRERadios.length === 0) return;
    
    globalCRERadios.forEach(radio => {
      radio.addEventListener('change', () => {
        this.querySelectorAll('.card-information').forEach(card => {
          const creFieldset = card.querySelector('fieldset[data-option-name*="CRE"]');
          if (!creFieldset) return;
          
          creFieldset.querySelectorAll('label').forEach(label => {
            if (label.textContent.trim().startsWith(radio.value)) {
              const input = document.getElementById(label.getAttribute('for'));
              if (input?.type === 'radio') {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
        });

        this.updateVariantAvailabilityForCRE(radio.value);
      });
    });

    this.querySelectorAll('.card-information fieldset[data-option-name*="CRE"]').forEach(fieldset => {
      fieldset.style.display = 'none';
    });

    setTimeout(() => {
      const firstChecked = Array.from(globalCRERadios).find(r => r.checked);
      if (firstChecked) {
        firstChecked.dispatchEvent(new Event('change'));
        this.updateVariantAvailabilityForCRE(firstChecked.value);
      }
    }, 100);
  }

  updateVariantAvailabilityForCRE(selectedCRE) {
    const creOptionName = this.dataset.creOptionName;
    if (!creOptionName) return;

    this.querySelectorAll('.card-information').forEach(card => {
      const productJson = card.querySelector('#ProductJson');
      if (!productJson) return;

      const variants = JSON.parse(productJson.textContent);
      if (!variants || variants.length === 0) return;

      const creFieldset = card.querySelector('fieldset[data-option-name*="CRE"]');
      if (!creFieldset) return;

      const variantsWithCRE = variants.filter(variant => {
        return variant.options && variant.options.includes(selectedCRE);
      });

      card.querySelectorAll('fieldset[data-option-name]').forEach(fieldset => {
        const optionName = fieldset.dataset.optionName;
        if (optionName.includes('CRE')) return;

        const optionInputs = fieldset.querySelectorAll('input[type="radio"]');
        
        optionInputs.forEach(input => {
          const label = card.querySelector(`label[for="${input.id}"]`);
          if (!label) return;
          
          const optionValue = label.textContent.trim().split('Variante')[0].trim();
          
          const hasAvailableVariant = variantsWithCRE.some(variant => {
            return variant.options && 
                   variant.options.includes(optionValue) && 
                   variant.available === true;
          });

          if (hasAvailableVariant) {
            input.classList.remove('disabled');
            input.disabled = false;
            label.classList.remove('disabled');
            const unavailableLabel = label.querySelector('.label-unavailable');
            if (unavailableLabel) {
              unavailableLabel.style.display = 'none';
            }
          } else {
            input.classList.add('disabled');
            input.disabled = true;
            label.classList.add('disabled');
            let unavailableLabel = label.querySelector('.label-unavailable');
            if (!unavailableLabel) {
              unavailableLabel = document.createElement('span');
              unavailableLabel.className = 'visually-hidden label-unavailable';
              label.appendChild(unavailableLabel);
            }
            unavailableLabel.style.display = '';
            
            if (input.checked) {
              input.checked = false;
              const firstAvailable = Array.from(optionInputs).find(inp => 
                !inp.classList.contains('disabled') && !inp.disabled
              );
              if (firstAvailable) {
                firstAvailable.checked = true;
                firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
        });
      });

      setTimeout(() => {
        const correctVariantId = this.getVariantId(card);
        if (correctVariantId) {
          card.setAttribute('data-variant-id', correctVariantId);
        }
        this.updateTotalPrice();
      }, 100);
    });
  }

  getVariantId(card) {
    const productJson = card.querySelector('#ProductJson');
    if (!productJson) return null;
    
    const variants = JSON.parse(productJson.textContent);
    const selectedOptions = [];
    
    card.querySelectorAll('fieldset[data-option-name] input[type="radio"]:checked').forEach(input => {
      const label = card.querySelector(`label[for="${input.id}"]`);
      if (label) {
        selectedOptions.push(label.textContent.trim().split('Variante')[0].trim());
      }
    });
    
    const variant = variants.find(v => 
      selectedOptions.every(opt => v.options.includes(opt))
    );
    
    return variant?.id || null;
  }

  attachSwatchListeners() {
    const swatchInputs = document.querySelectorAll('input[data-variant-id]');
    swatchInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const prGridItem = input.closest('.pr_grid_item');
        if (prGridItem && input.checked) {
          const correctVariantId = this.getVariantId(prGridItem);
          
          if (correctVariantId) {
            prGridItem.setAttribute('data-variant-id', correctVariantId);
          } else {
            prGridItem.setAttribute('data-variant-id', input.getAttribute('data-variant-id'));
          }
          
          setTimeout(() => {
            this.updateTotalPrice();
          }, 500);
        }
      });
    });
  }

  attachAddToCartListener() {
    if (!this.addToCartButton) return;
    this.addToCartButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleAddToCart();
    });
  }

  attachKitImageClickHandler() {
    const kitImages = this.querySelectorAll('.kit__image-wrapper img[data-image]');
    kitImages.forEach(img => {
      img.addEventListener('click', () => {
        const imageUrl = img.getAttribute('data-image');
        const imgEl = document.querySelector('.product__media-item.is-active .product__media img');
        if (imgEl) {
          imgEl.src = imageUrl;
          imgEl.srcset = imageUrl;
        }
      });
    });
  }

  getItems() {
    const items = [];
    const elementVariantIds = document.querySelectorAll('.pr_grid_item[data-variant-id]');
    elementVariantIds.forEach((element) => {
      items.push({
        id: element.dataset.variantId,
        quantity: 1,
        properties: {
          _product_type: this.dataset.productType
        }
      });
    });
    return items;
  }

  updateTotalPrice() {
    let total = 0;
    const selectedGroups = document.querySelectorAll('.pr_grid_item[data-variant-id]');
    selectedGroups.forEach(group => {
      const selectedInput = group.querySelector('input[data-variant-id][type="radio"]:checked, input[data-variant-id][type="hidden"]');
      let price = null;
      if (selectedInput && selectedInput.dataset.price) {
        price = parseFloat(selectedInput.dataset.price);
      }
      if (price) {
        total += price / 100;
      }
    });
    if (this.totalPriceElement) {
      this.totalPriceElement.textContent = this.formatMoney(total);
    }
    if (this.totalPriceProductBar) {
      this.totalPriceProductBar.textContent = this.formatMoney(total);
    }
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(amount);
  }

  async handleAddToCart() {
    // --- INÍCIO: Validação de Restrição de Carrinho ---
    this.RESTRICTED_TYPES = ['Material', 'Uniforme'];
    this.RESTRICTION_ERROR_MESSAGE = '<h4>Você só pode comprar um tipo de benefício por vez: Uniforme ou Material Escolar</h4><p>Finalize a compra atual ou remova os itens do carrinho para comprar este produto.</p>';
    const productTypeToAdd = this.addToCartButton.getAttribute('data-product-type');

    if (productTypeToAdd && this.RESTRICTED_TYPES.includes(productTypeToAdd)) {
      this.addToCartButton.setAttribute('aria-disabled', true);
      this.addToCartButton.classList.add('loading');

      try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Falha ao buscar carrinho');
        const cart = await cartResponse.json();

        let existingRestrictedType = null;
        if (cart.item_count > 0) {
          for (const item of cart.items) {
            if (
              item.properties &&
              item.properties._product_type &&
              this.RESTRICTED_TYPES.includes(item.properties._product_type)
            ) {
              existingRestrictedType = item.properties._product_type;
              break;
            }
          }
        }

        if (existingRestrictedType && existingRestrictedType !== productTypeToAdd) {
          this.handleMultiCategoryErrorMessage(this.RESTRICTION_ERROR_MESSAGE);
          this.error = true;
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.removeAttribute('aria-disabled');
          console.warn('Adição ao carrinho bloqueada: tipos conflitantes.');
          return;
        } else {
          this.addToCartButton.classList.remove('loading');
          this.addToCartButton.removeAttribute('aria-disabled');
        }

      } catch (error) {
        console.error('Erro ao validar restrição do carrinho:', error);
        this.handleError('Erro ao verificar o carrinho. Tente novamente.');
        this.error = true;
        this.addToCartButton.classList.remove('loading');
        this.addToCartButton.removeAttribute('aria-disabled');
        if (this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
        return;
      }
    }
    // --- FIM: Validação de Restrição de Carrinho ---

    const cartDrawer = document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    const formData = { items: this.getItems() };
    if (cartDrawer) {
      formData.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
      cartDrawer.setActiveElement(this.addToCartButton);
    }
    config.body = JSON.stringify(formData);
    try {
      const response = await fetch(routes.cart_add_url, config);
      const result = await response.json();
      if (result.status) {
        this.handleError(result.description);
      } else {
        cartDrawer.renderContents(result);
        cartDrawer.classList.remove('is-empty');
      }
    } catch (e) {
      console.error(e);
    }
    this.handleError('Erro ao adicionar ao carrinho. Tente novamente.');
  }

  handleMultiCategoryErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMultiCategoryMessageWrapper =
      this.errorMultiCategoryMessageWrapper || this.querySelector('.product-multi-category__error-message-wrapper');
    if (!this.errorMultiCategoryMessageWrapper) return;
    this.errorMessage = this.errorMultiCategoryMessageWrapper.querySelector('.product-multi-category__error-message');

    this.errorMultiCategoryMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.innerHTML = errorMessage;
    }

    this.errorMultiCategoryMessageWrapper.querySelector('.alert__multi-category-close').addEventListener('click', () => {
      this.errorMultiCategoryMessageWrapper.toggleAttribute('hidden', true);
    });
  }

  handleError(message) {
    if (!this.errorMessageWrapper) return;
    this.errorMessageWrapper.hidden = !message;
    if (message && this.errorMessage) {
      this.errorMessage.textContent = message;
    }
  }
}

if (!customElements.get('product-kit-uniforme')) {
  customElements.define('product-kit-uniforme', ProductKitUniforme);
}